export type ValueOf<T> = T[keyof T]

export function guardIsEnum<T extends { [key: string]: string | number }>(
  value: string | number,
  obj: T
): value is T[keyof T] {
  return Object.values(obj).includes(value)
}
